export const SLICE = 'calendar';

export const getTableSort = state => state[SLICE].tableSort;
export const getFilters = state => state[SLICE].filters;
export const getRestoringState = state => state[SLICE].restoringState;
